import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { MenuItem, Select } from "@mui/material";
import "./Monitoring.css";
import ACDMonitoring from "./ACDMonitoring";
import AgentMonitoring from "./AgentMonitoring";
import CallMonitoring from "./CallMonitoring";
import IVRMonitoring from "./IVRMonitoring";
import AgentMonitoringIcon from "../Images/AgentMonitoringIcon.svg";
import CallMonitoringIcon from "../Images/CallMonitoringIcon.svg";
import HubOutlineIcon from "../Images/HubOutlineIcon.svg";
import IVRMonitoringIcon from "../Images/IVRMonitoringIcon.svg";
import { getACDDevice, getIVRDevice } from "../Store/Actions/MonitoringAction";

const Monitoring = () => {
  const [selected, setSelected] = useState("");
  const [IVRDevices, setIVRDevices] = useState([]);
  const [selectedIVRDeviceID, setSelectedIVRDeviceID] = useState(1);
  const [ACDDevices, setACDDevices] = useState([]);
  const [selectedACDDeviceID, setSelectedACDDeviceID] = useState(null);
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    selected === "ivr" &&
      getIVRDevice()
        .then((response) => {
          if (response.status) {
            console.log("IVR devices: ", response.data);
            setIVRDevices(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => console.log("err", err));

    selected === "acd" &&
      getACDDevice(myInfo.user.ClientID)
        .then((response) => {
          if (response.status) {
            console.log("ACD devices: ", response.data);
            setACDDevices(response.data);
            response.data.length && setSelectedACDDeviceID(-1);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => console.log("err", err));
  }, [selected]);

  const renderHeader = () => {
    let icon;
    let title;

    switch (selected) {
      case "call":
        icon = CallMonitoringIcon;
        title = "Call Monitoring";
        break;

      case "agent":
        icon = AgentMonitoringIcon;
        title = "Agent Monitoring";
        break;

      case "acd":
        icon = HubOutlineIcon;
        title = "ACD Monitoring";
        break;

      case "ivr":
        title = "IVR Monitoring";
        break;

      default:
        break;
    }

    return (
      <div>
        {selected === "ivr" ? (
          <img src={IVRMonitoringIcon} height="28" width="28" />
        ) : (
          <img src={icon} alt="" height="28" width="28" />
        )}

        <p>{title}</p>

        {selected === "ivr" && (
          <Select
            className="select-ivr"
            label="IVR Name"
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                { border: 0 },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { border: 0 },
            }}
            value={selectedIVRDeviceID}
            onChange={(e) => setSelectedIVRDeviceID(e.target.value)}
          >
            {IVRDevices.length ? (
              IVRDevices?.map((IVRDevice) => (
                <MenuItem
                  key={IVRDevice.IVRDeviceID}
                  value={IVRDevice.IVRDeviceID}
                >
                  <div style={{ paddingRight: 10 }}>{IVRDevice.Name}</div>
                </MenuItem>
              ))
            ) : (
              <MenuItem>
                <div style={{ paddingRight: 10 }}>No IVR Device found</div>
              </MenuItem>
            )}
          </Select>
        )}

        {selected === "acd" && (
          <Select
            className="select-ivr"
            label="ACD Device"
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                { border: 0 },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                { border: 0 },
            }}
            value={selectedACDDeviceID}
            onChange={(e) => setSelectedACDDeviceID(e.target.value)}
          >
            {ACDDevices.length ? (
              [{ acddeviceid: -1, acdname: "All" }, ...ACDDevices].map((ACDDevice) => (
                <MenuItem
                  key={ACDDevice.acddeviceid}
                  value={ACDDevice.acddeviceid}
                >
                  <div style={{ paddingRight: 10 }}>{ACDDevice.acdname}</div>
                </MenuItem>
              ))
            ) : (
              <MenuItem>
                <div style={{ paddingRight: 10 }}>No ACD Device found</div>
              </MenuItem>
            )}
          </Select>
        )}
      </div>
    );
  };

  return (
    <div className="monitoring">
      <div className="list_header">
        <div className="list_headerLeft">
          <h1>Monitoring</h1>
        </div>
      </div>

      <div className="containerMonitoring">
        {selected !== "" && (
          <header className={selected}>
            {renderHeader()}

            <Icon
              className="close-button"
              icon="ph:x-bold"
              height="28"
              width="28"
              onClick={() => setSelected("")}
            />
          </header>
        )}

        {selected === "" && (
          <div className="grid-container">
            <div className="grid-item call" onClick={() => setSelected("call")}>
              <img src={CallMonitoringIcon} alt="" />
              <p>Call Monitoring</p>
            </div>

            <div
              className="grid-item agent"
              onClick={() => setSelected("agent")}
            >
              <img src={AgentMonitoringIcon} alt="" />
              <p>Agent Monitoring</p>
            </div>

            <div className="grid-item acd" onClick={() => setSelected("acd")}>
              <img src={HubOutlineIcon} alt="" />
              <p>ACD Monitoring</p>
            </div>

            <div className="grid-item ivr" onClick={() => setSelected("ivr")}>
              <img src={IVRMonitoringIcon} alt="" />
              <p>IVR Monitoring</p>
            </div>
          </div>
        )}

        {selected === "call" && <CallMonitoring />}
        {selected === "agent" && <AgentMonitoring />}

        {selected === "ivr" && (
          <IVRMonitoring IVRDeviceID={selectedIVRDeviceID} />
        )}

        {selected === "acd" && (
          <ACDMonitoring ACDDeviceID={selectedACDDeviceID} />
        )}
      </div>
    </div>
  );
};

export default Monitoring;
